<template>
    <svg fill="currentColor" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
        viewBox="0 0 491.996 491.996" xml:space="preserve">
        <g>
            <g>
                <path d="M414.5,4.316C411.848,1.56,408,0,404.224,0H283.428c-7.636,0-14.368,6.316-14.368,13.956V24.48
                c0,7.644,6.732,13.956,14.368,13.956H353.9L156.672,235.62c-5.408,5.408-5.408,14.176,0,19.584l7.444,7.432
                c2.608,2.612,6.088,4.048,9.8,4.048c3.716,0,7.408-1.44,10.02-4.056L380.528,66.252v68.812c0,7.636,5.792,14.84,13.432,14.84
                h10.524c3.692,0,7.48-1.936,10.104-4.56c2.624-2.624,4.376-6.596,4.376-10.28V14.224C418.968,10.448,417.144,6.86,414.5,4.316z"/>
            </g>
        </g>
    <g>
        <g>
            <path d="M338.552,246.452c0-3.712-1.44-7.168-4.052-9.772l-7.444-7.416c-5.22-5.224-14.052-5.224-19.284,0l-196.3,196.632v-68.812
                c0-7.644-6.868-14.992-14.512-14.992H86.432c-7.644,0-13.4,7.348-13.4,14.992v120.832c0,3.78,1.28,7.292,3.932,9.836
                c2.652,2.756,5.96,4.244,9.74,4.244h120.784c7.64,0,15.448-6.164,15.448-13.808V467.66c0-7.64-7.804-14.1-15.448-14.1h-70.472
                L334.5,256.192C337.108,253.584,338.552,250.156,338.552,246.452z"/>
            </g>
        </g>
    </svg>
</template>